import { type SampledValue } from '@/types/swagger';
import { type AxiosError } from 'axios';
import { http } from 'config';
import { callNextPage } from 'util/callNextPage';

import { SAMPLED_VALUES_BY_ID_URL, SAMPLED_VALUES_BY_TRANSACTION_URL } from './endpoints';

export const getSampledValueById = async (sampledValueId: number) =>
  await http.get<SampledValue>(SAMPLED_VALUES_BY_ID_URL(sampledValueId));

// ! Esto tiene que ser manejado por la query fn, no en la llamada a la api en si
export const getSampledValuesByTransactionId = async (
  transactionId: number,
  pageSize = 999
): Promise<SampledValue[] | AxiosError> => {
  return callNextPage(`${SAMPLED_VALUES_BY_TRANSACTION_URL(transactionId)}?page_size=${pageSize}`);
};
